// extracted by css-extract-rspack-plugin
export default {"cls1":"Modal-cls1_zgZ","cls2":"Modal-cls2_A92 Modal-cls1_zgZ"};